import React, { createContext, useContext, useState, useEffect } from 'react';
import de from '../translations/de.json';
import en from '../translations/en.json';
import tr from '../translations/tr.json';
import ru from '../translations/ru.json';

const translations = { de, en, tr, ru };

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('alka-language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('alka-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, availableLanguages: ['de', 'en', 'tr', 'ru'] }}>
      {children}
    </LanguageContext.Provider>
  );
};
